// Utilitários para manipulação de datas com fuso horário de São Paulo (UTC-3)

/**
 * Converte uma data local para o fuso horário de São Paulo
 * @param {Date|string} date - Data a ser convertida
 * @returns {Date} Data ajustada para São Paulo
 */
export function toSaoPauloTime(date) {
  const d = new Date(date);
  // Converter para string no formato ISO com timezone de São Paulo
  return new Date(d.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }));
}

/**
 * Converte uma data UTC do Supabase para o horário de São Paulo
 * @param {string} utcDate - Data em formato ISO UTC
 * @returns {Date} Data no horário de São Paulo
 */
export function fromUTCToSaoPaulo(utcDate) {
  if (!utcDate) return null;
  const d = new Date(utcDate);
  return new Date(d.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }));
}

/**
 * Formata uma data para salvar no Supabase mantendo o horário de São Paulo
 * @param {Date|string} date - Data a ser formatada
 * @returns {string} Data em formato ISO
 */
export function toSupabaseDate(date) {
  if (!date) return null;
  const d = new Date(date);
  // Ajustar para São Paulo antes de converter para ISO
  const saoPauloDate = new Date(d.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }));
  return saoPauloDate.toISOString();
}

/**
 * Retorna a data/hora atual no fuso horário de São Paulo
 * @returns {Date} Data atual em São Paulo
 */
export function nowInSaoPaulo() {
  return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' }));
}

/**
 * Formata uma data para exibição no formato brasileiro
 * @param {Date|string} date - Data a ser formatada
 * @param {boolean} includeTime - Se deve incluir a hora
 * @returns {string} Data formatada
 */
export function formatBrazilianDate(date, includeTime = false) {
  if (!date) return '';
  const d = fromUTCToSaoPaulo(date);
  
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'America/Sao_Paulo'
  };
  
  if (includeTime) {
    options.hour = '2-digit';
    options.minute = '2-digit';
  }
  
  return d.toLocaleString('pt-BR', options);
}
